// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

// COB-502: the username companion field for passcode surfaces that have no
// email input of their own.
//
// Safari/iCloud Keychain (and Chrome's password manager) key a saved
// credential on a username. A password form with no username field saves a
// BLANK-username entry for the origin, and a blank entry is a classic cause
// of "sometimes offered, sometimes not" on the next visit — the pollution
// then degrades the *login* form's fill behaviour too. Every passcode surface
// that is not the login form itself (which carries a real email field)
// therefore renders this read-only companion, so the save/update it triggers
// is attributed to the signed-in account.
//
// Hidden OFF-SCREEN — never `display: none`, `hidden`, or `type="hidden"`: a
// field the engine treats as non-rendered is skipped by the credential
// heuristics entirely, which is exactly the failure this component exists to
// avoid. It stays out of the tab order (`tabIndex={-1}`) and is `readOnly`,
// so it is inert for a sighted keyboard user while remaining a real, labelled
// email input in the accessibility tree (hence no `aria-hidden`, which would
// also be invalid on a focusable element).

export function PasswordManagerUsername({
  id,
  email,
}: {
  /** DOM id, unique per surface — the `label for` target. */
  id: string;
  /** The account this passcode belongs to. */
  email: string;
}) {
  return (
    <div class="pm-username-offscreen">
      <label for={id}>Email</label>
      <input
        id={id}
        name="username"
        type="email"
        autocomplete="username"
        value={email}
        readOnly
        tabIndex={-1}
      />
    </div>
  );
}
